import { graphql } from "~/gql";

export const UPDATE_LIBRARY_TECHNOLOGIES = graphql(/* GraphQL */ `
  mutation UpdateLibraryTechnologies($data: [UpdateLibraryTechnologyInput!]!) {
    updateLibraryTechnologies(data: $data) {
      ...LibraryTechnologyParts
    }
  }
`);
